import React, { useState, ReactElement } from 'react';
import type { NextPageWithLayout } from '@/pages/_app';
import AuthLayout from '@/layouts/AuthLayout';
import Image from 'next/image';
import { generateSEO } from 'lib/utils/seoHelper';
import { Alert, Col, Container, Form, Row } from 'react-bootstrap';
import BaseButton from '@/components/base/BaseButton';
import api from '@/api/index';
import { toast } from 'react-toastify';
import { FaInfoCircle } from 'react-icons/fa';
const Page: NextPageWithLayout = () => {
  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState<any>({});
  const [form, setForm] = useState({
    email: '',
    alert: ''
  });
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formTarget = e.currentTarget;
    if (formTarget.checkValidity() === false) {
      setValidated(true);
    }
    try {
      setLoading(true);
      setErrors({});
      setValidated(false);
      const response = await api.auth.forgotPassword(form.email);
      setForm({
        email: '',
        alert: response.message
      });
    } catch (error: any) {
      if (error.response) {
        setErrors(error.response.data.errors);
      } else {
        toast.error('Something went wrong, please try again later.', {
          theme: 'colored'
        });
      }
    } finally {
      setLoading(false);
    }
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      value
    } = e.target;
    setForm({
      ...form,
      [name]: value
    });
  };
  return <>
      {generateSEO('Forgot Password - Zremax', 'Recover access to your Zremax account. Reset your password securely with our easy Forgot Password process. Get back to your account in just a few clicks!', 3)}
      <Container className="forgot-password">
        <h1 className="forgot-password_header">Forgot <span className="forgot-password_header-highlight">Password</span></h1>
        <p className="forgot-password_subheader">Enter your email address below and we will send you a link to <br /> reset your password.</p>
        <Row>
          <Col xs={12} md={6}>
            <Alert variant="success" className="login_error" show={!!form.alert}>
              <FaInfoCircle /> {form.alert}
            </Alert>
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Form.Group controlId="loginForm.email">
                <Form.Control value={form.email} onChange={handleChange} name="email" type="email" placeholder="Email" maxLength={191} required isInvalid={!!errors.email} />
                <Form.Control.Feedback type="invalid">
                  {errors.email}
                </Form.Control.Feedback>
              </Form.Group>
              <BaseButton className="forgot-password_button" variant="primary" type="submit" loading={loading}>Forgot Password</BaseButton>
            </Form>
          </Col>
          <Col className="login_image" md={6}>
            <Image fill={false} width={347} height={575} className="forgot-password_image_image" src={require('../../../public/images/misc/forgot-password.png')} alt="Forgot Password" placeholder="blur" />
          </Col>
        </Row>
      </Container>
    </>;
};
Page.getLayout = function getLayout(page: ReactElement) {
  return <AuthLayout>
        {page}
    </AuthLayout>;
};
export default Page;